/** Extensible user types for admin create / edit flows. Add new entries here. */
export const USER_TYPES = [
  {
    value: "",
    label: "Standard",
    description: "Full product access with normal onboarding.",
    accent: "#3730a3",
    softBg: "#eef2ff",
    softBorder: "#c7d2fe",
  },
  {
    value: "corporates",
    label: "Corporate",
    description: "Skips onboarding. Dashboards + Chat only.",
    accent: "#0f766e",
    softBg: "#ccfbf1",
    softBorder: "#99f6e4",
  },
];

export function getUserTypeMeta(value) {
  const key = value === "corporates" ? "corporates" : "";
  return USER_TYPES.find((t) => t.value === key) || USER_TYPES[0];
}

/** Normalize API value → form/select value. */
export function normalizeUserTypeValue(value) {
  if (!value) return "";
  const match = USER_TYPES.find((t) => t.value && t.value === value);
  return match ? match.value : "";
}

/** Payload value for API: omit empty as null. */
export function userTypeForApi(value) {
  return value || null;
}
